import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useGetPortalProjectQuery } from '../../redux/api/compassPortal';
import DataCheckPanel from './DataCheckPanel';

// Kept for old bookmarks. Client users normally open the same content in a
// drawer from their file row, without leaving the project.
const DataCheckPage = () => {
    const { projectId } = useParams();
    const navigate = useNavigate();
    const { data: project } = useGetPortalProjectQuery({ projectId });
    if (!project) return <div style={{ textAlign: 'center', padding: 80 }}><Spin size="large" /></div>;
    return (
        <div style={{ width: '100%', maxWidth: 900 }}>
            <button className="cp-back-link" onClick={() => navigate(`/compass-portal/${projectId}`)}>
                <ArrowLeftOutlined /> Back to project
            </button>
            <h2>Check your file</h2>
            <p style={{ color: '#555' }}>See how we'll organise it, then approve it if it looks right.</p>
            <DataCheckPanel clientName={project.client_name} />
        </div>
    );
};

export default DataCheckPage;
